import { type DialogProps } from "@mui/material";
import type { ChangeEvent } from "react";
import { type FC } from "react";
import type { ComparisonObjectValue } from "../../../../services/api/instances/comparisonAPI/types";
import { createStorageObjectApi } from "../../../../services/lib/storageObjectManager";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppInput } from "../../../../shared/components/AppInput";
import { FolderNameChangeModal } from "../../../Modals/FolderNameChangeModal";
import { useCompare } from "../../hooks/useCompare";
import {
  selectComparisonObjects,
  selectSelectedComparisonObject,
} from "../../redux/selectors";
import {
  setComparisonObjects,
  setSelectedComparisonObject,
} from "../../redux/slice";
import styles from "./styles.module.css";
import { StorageObject } from "../../../../services/api/instances/storageApi/types/object_types";

interface Props extends DialogProps {
  closeModal: () => void;
  childId?: string;
}

export const ComparisonFolderNameChange: FC<Props> = ({
  childId,
  closeModal,
  ...props
}) => {
  const dispatch = useAppDispatch();
  const selectedComparisonObject = useAppSelector(
    selectSelectedComparisonObject,
  );
  const comparisonObjects = useAppSelector(selectComparisonObjects);
  const { updateComparisonObject } = useCompare();

  const onComparisonNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    const storage =
      createStorageObjectApi<ComparisonObjectValue>(comparisonObjects);
    const updatedComparisonObject = {
      ...selectedComparisonObject,
      friendly_name: event.target.value,
    };
    const updatedComparisonObjects = storage.updateById(
      selectedComparisonObject?.id as string,
      {
        friendly_name: event.target.value,
      },
      true,
    );
    updateComparisonObject(
      updatedComparisonObject as StorageObject<ComparisonObjectValue>,
    );
    dispatch(
      setComparisonObjects(
        updatedComparisonObjects as StorageObject<ComparisonObjectValue>[],
      ),
    );
    dispatch(
      setSelectedComparisonObject(
        updatedComparisonObject as StorageObject<ComparisonObjectValue>,
      ),
    );
  };

  return (
    <FolderNameChangeModal
      closeModal={closeModal}
      onClose={closeModal}
      onOk={() => {
        closeModal();
      }}
      {...props}
    >
      <div className={styles.container}>
        <AppInput
          value={selectedComparisonObject?.friendly_name as string}
          className={styles.input}
          onChange={onComparisonNameChange}
        />
      </div>
    </FolderNameChangeModal>
  );
};
